import { render } from "./OperatorDashboard.vue?vue&type=template&id=28c68c85"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__